var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPisces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#E14C72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0841 14.3794C12.8016 14.2608 12.1123 12.8065 12.1123 9.99072C12.1123 7.1749 12.8016 5.72066 13.0841 5.60201C13.3778 5.59523 13.614 5.35569 13.614 5.06077C13.614 4.76586 13.3711 4.51953 13.0728 4.51953C11.5959 4.51953 11.1112 7.40315 11.04 9.44948H8.90213C8.83095 7.40315 8.3462 4.51953 6.86937 4.51953C6.56993 4.51953 6.32812 4.76247 6.32812 5.06077C6.32812 5.35908 6.56428 5.59636 6.85807 5.60201C7.14055 5.72066 7.82982 7.1749 7.82982 9.99072C7.82982 12.8065 7.14055 14.2608 6.85807 14.3794C6.56428 14.3862 6.32812 14.6257 6.32812 14.9207C6.32812 15.2156 6.57106 15.4619 6.86937 15.4619C8.3462 15.4619 8.83095 12.5783 8.90213 10.532H11.04C11.1112 12.5783 11.5959 15.4619 13.0728 15.4619C13.3722 15.4619 13.614 15.219 13.614 14.9207C13.614 14.6224 13.3778 14.3851 13.0841 14.3794Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPisces);
export default __webpack_public_path__ + "static/media/pisces.998239ffa4bf06ce79486c5a0da41ddd.svg";
export { ForwardRef as ReactComponent };